module.exports = __webpack_public_path__ + "static/img/pc.65d7fd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/北京中加学校/pc.svg
// module id = 6kRz
// module chunks = 16